var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileIconDocx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.60048 0H9.29409L14.9606 5.90882V17.3995C14.9606 18.8344 13.795 20 12.3562 20H2.60051C1.1656 20 4.11262e-10 18.8344 4.11262e-10 17.3995V2.60051C-2.52695e-05 1.1656 1.16558 0 2.60048 0Z",
    fill: "#0263D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28638 0V5.86268H14.9605L9.28638 0Z",
    fill: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1173 10.4059H4.84321C4.60085 10.4059 4.40081 10.2097 4.40081 9.96733C4.40081 9.72499 4.60085 9.52879 4.84321 9.52879H10.1173C10.3597 9.52879 10.5558 9.72499 10.5558 9.96733C10.5558 10.2097 10.3597 10.4059 10.1173 10.4059ZM8.35927 15.68H4.84321C4.60085 15.68 4.40081 15.4838 4.40081 15.2414C4.40081 14.9991 4.60085 14.8029 4.84321 14.8029H8.35927C8.60164 14.8029 8.79781 14.9991 8.79781 15.2414C8.79781 15.4838 8.60164 15.68 8.35927 15.68ZM10.1173 13.9219H4.84321C4.60085 13.9219 4.40081 13.7257 4.40081 13.4834C4.40081 13.241 4.60085 13.0449 4.84321 13.0449H10.1173C10.3597 13.0449 10.5558 13.241 10.5558 13.4834C10.5558 13.7257 10.3597 13.9219 10.1173 13.9219ZM10.1173 12.1639H4.84321C4.60085 12.1639 4.40081 11.9677 4.40081 11.7254C4.40081 11.483 4.60085 11.2868 4.84321 11.2868H10.1173C10.3597 11.2868 10.5558 11.483 10.5558 11.7254C10.5558 11.9677 10.3597 12.1639 10.1173 12.1639Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIconDocx);
export default __webpack_public_path__ + "static/media/FileIcon_docx.9c18fbc026cc63084ff2513943e92e30.svg";
export { ForwardRef as ReactComponent };